<template>
  <span>
    <v-row no-gutters>
      <!-- Type -->
      <v-col cols="12">
        <span class="">
          {{ type }}
        </span>
      </v-col>
      
      <!-- Number -->
      <v-col cols="auto">
        <span class="font-weight-bold text-body-2">
          {{ number }}
        </span>
      </v-col>

      <!-- Country, description -->
      <v-col
        v-if="description || country"
        cols="12"
      >
        <span v-if="description">
          {{ description }}
        </span>
        <span v-if="country">{{ `- ${country}` }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <!-- Issue, expiration -->
      <v-col v-if="issued" cols="auto" class="pr-2">
        {{ `Issued: ${issued}` }}
      </v-col>
      <v-col v-if="expiration" cols="auto">
        {{ `Expires: ${expiration}` }}
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "ID",
  data() {
    return {};
  },
  props: {
    type: String,
    description: String,
    country: String,
    number: String,
    issued: String,
    expiration: String,
    icon: String,
  },
  methods: {},
};
</script>
